require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./rglements-et-directives-0-11.json") })
        }
      }, "path---rglements-et-directives-0-11");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---rglements-et-directives-0-11!./.cache/json/rglements-et-directives-0-11.json
// module id = 554
// module chunks = 231608221292675